// @core/api/endpoints/affiliate/reject_payout.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PayoutResponse,
  RejectPayoutRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Reject payout
 * Performs reject operation on payout.
 */
export async function RejectPayout(
  payout_id: string,
  data: RejectPayoutRequest,
  options?: RequestOptions
): Promise<PayoutResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payouts/:payout_id/reject`;
  requestPath = requestPath.replace(':payout_id', encodeURIComponent(payout_id));
  const requestOptions = options;
  return client.post<PayoutResponse>(requestPath, data, requestOptions);
}
